<app-standard-layout>
    <page-body>
        <div class="col-md-12">
            <h2 fxFlex="100" fxLayoutAlign="center center">
            Logging you out, please wait...
            </h2>
        </div>
    </page-body>
</app-standard-layout>
